// extracted by mini-css-extract-plugin
export var table = "_um-0";